import { useEffect, useRef } from "react";
import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

export default function useAppStateChange(onChange: (isActive: boolean) => void) {
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const listenerPromise = App.addListener("appStateChange", ({ isActive }) => {
      onChangeRef.current(isActive);
    });

    return () => {
      listenerPromise.then((listener) => listener.remove());
    };
  }, []);
}
